module.exports = __webpack_public_path__ + "img/tgcpbj.fa6861f0.png";